const STORAGE_KEY_PREFIX = "afrimed:sponsor-payment:pending:v1";

function storageKey(userId = "", source = "") {
  return `${STORAGE_KEY_PREFIX}:${String(userId || "").trim()}:${String(source || "").trim()}`;
}

export function readPendingSponsorPayment(userId = "", source = "") {
  const key = storageKey(userId, source);
  if (!String(userId || "").trim() || !String(source || "").trim()) return null;

  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function savePendingSponsorPayment(userId = "", source = "", value = {}) {
  const key = storageKey(userId, source);
  if (!String(userId || "").trim() || !String(source || "").trim()) return;

  try {
    window.localStorage.setItem(
      key,
      JSON.stringify({
        ...value,
        source,
        userId: String(userId || "").trim(),
        savedAt: new Date().toISOString(),
      }),
    );
  } catch {
    // Ignore storage write failures.
  }
}

export function clearPendingSponsorPayment(userId = "", source = "") {
  const key = storageKey(userId, source);
  if (!String(userId || "").trim() || !String(source || "").trim()) return;

  try {
    window.localStorage.removeItem(key);
  } catch {
    // Ignore storage delete failures.
  }
}
